import React, { useContext } from "react";
import { AddUserDataContext } from "context/AddUserContext";
import styled from "styled-components";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const EditIconDefault = `${CDN_URL}common/icon-edit-default-lg.svg`;
const EditIconHover = `${CDN_URL}common/icons-edit-selected-lg.svg`;

const ReviewStyle = styled.div`
  width: 100%;
  .user-details-wrapper,
  .dc-locations-wrapper,
  .badge-wrapper {
    display: flex;
    .user-details,
    .dc-locations-details,
    .badge-details {
      width: 100%;
    }
    .user-details {
      width: 100%;
      margin-bottom: 0px;
    }

    .dc-locations-details {
      width: 100%;
      margin-bottom: 0px;
    }
    .detail-row {
      display: flex;
      height: 20px;
      margin-bottom: 15px;
      .label {
        margin-top: 4px;
        width: 70px;
      }
      .value {
        width: 100%;
        margin-left: 10px;
        display: flex;
        flex-wrap: wrap;
        .location {
          margin-right: 5px;
        }
      }
    }
    .edit-icon {
      cursor: pointer;
      img {
        width: 15px;
        height: 15px;
      }
    }
  }
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    width: 100%;
    .user-details-wrapper,
    .dc-locations-wrapper,
    .badge-wrapper {
      display: flex;
      .user-details,
      .dc-locations-details,
      .badge-details {
        width: 100%;
      }
      .detail-row {
        display: flex;
        height: 35px;
        margin-bottom: 25px;
        .label {
          width: 90px;
        }
        .value {
          width: 100%;
          margin-left: 15px;
          margin-top: 0px;
          display: flex;
          .location {
            margin-right: 15px;
          }
        }
      }
      .edit-icon {
        img {
          width: 15px;
          height: 15px;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    width: 100%;
    .user-details-wrapper,
    .dc-locations-wrapper,
    .badge-wrapper {
      display: flex;
      .user-details,
      .dc-locations-details,
      .badge-details {
        width: 100%;
      }
      .user-details {
        width: 100%;
        margin-bottom: 0px;
      }

      .dc-locations-details {
        width: 100%;
        margin-bottom: 0px;
      }
      .detail-row {
        display: flex;
        height: 35px;
        margin-bottom: 25px;
        .label {
          width: 140px;
        }
        .value {
          width: 100%;
          margin-left: 15px;
          margin-top: 0px;
          display: flex;
          margin-top: 4px;
          .location {
            margin-right: 15px;
          }
        }
      }
      .edit-icon {
        img {
          width: 15px;
          height: 15px;
        }
      }
    }
  }
`;

function getEditIcon(activePage, setActivePageIndex) {
  return (
    <div className="edit-icon">
      <img
        src={EditIconDefault}
        onMouseOver={(e) => {
          e.currentTarget.src = EditIconHover;
        }}
        onMouseOut={(e) => {
          e.currentTarget.src = EditIconDefault;
        }}
        alt="edit-icon"
        onClick={() => setActivePageIndex(activePage)}
      />
    </div>
  );
}

export const ReviewScreen = ({ setActivePageIndex, type }) => {
  const { inputs } = useContext(AddUserDataContext);
  const locations = inputs?.locations;
  return (
    <ReviewStyle>
      <div className="user-details-wrapper">
        <div className="user-details">
          <div className="detail-row">
            <div className="label labels21">First Name :</div>
            <div className="value body10">{inputs.firstname}</div>
          </div>
          <div className="detail-row">
            <div className="label labels21">Last Name :</div>
            <div className="value body10">{inputs.lastname}</div>
          </div>
          <div className="detail-row">
            <div className="label labels21">Email :</div>
            <div className="value body10">{inputs.email}</div>
          </div>
        </div>
        {type !== "BADGE_REQUEST" && getEditIcon(0, setActivePageIndex)}
      </div>
      <div className="dc-locations-wrapper">
        <div className="dc-locations-details">
          <div className="detail-row">
            <div className="label labels21">Locations :</div>
            <div className="value body10">
              {locations.map((location) => (
                <div className="location">{`${location}`}</div>
              ))}
            </div>
          </div>
        </div>
        {type !== "BADGE_REQUEST"
          ? getEditIcon(1, setActivePageIndex)
          : getEditIcon(0, setActivePageIndex)}
      </div>

      {!locations.includes("No Access") && (
        <div className="badge-wrapper">
          <div className="badge-details">
            <div className="detail-row">
              <div className="label labels21">Badge :</div>
              <div className="value body10">{inputs.badgeAccess}</div>
            </div>
          </div>
          {type !== "BADGE_REQUEST"
            ? getEditIcon(2, setActivePageIndex)
            : getEditIcon(1, setActivePageIndex)}
        </div>
      )}
    </ReviewStyle>
  );
};
